export default "__VITE_ASSET__p8i2cCp3__"